export default __webpack_public_path__ + "static/media/prbicon_Historial.d0177d99.svg";